import CorporateProduct from '@/creditflowresearch/domain/Product/entities/CorporateProduct';
import { ProductType, ProductAbbreviations } from '@/creditflowresearch/domain/Product/types/ProductType';
import {
  IGC_PRODUCT_ID,
  IGC_ABBREVIATION,
  IGC_TYPE,
} from '@/creditflowresearch/domain/Product/constants';

class IgcProduct extends CorporateProduct {
  static readonly PRODUCT_ID: string = IGC_PRODUCT_ID;

  static readonly ABBREVIATION: ProductAbbreviations = IGC_ABBREVIATION;

  static readonly TYPE: ProductType = IGC_TYPE;
}

export default IgcProduct;
